import Journey from "../../components/Pages/Tracking/Journey/Journey";

const TrackingJourney = () => {
  return (
    <div>
      <Journey />
    </div>
  );
};

export default TrackingJourney;
